module.exports = __webpack_public_path__ + "img/c_photo_6.1b384c8a.png";